
































































































import { SimilarityAnalysisResult } from '@/interfaces/types/AnalysisResult';
import Vue, { PropType } from 'vue';
import NumDataDisplay from '../DashboardView/Summary/NumDataDisplay.vue';

import UniversalBarChart from '../common/Chart/UniversalBarChart.vue';
import Button from '../common/Button/Button.vue';

import { exportJSONToFile } from '../../utils/download';

export default Vue.extend({
  components: {
    NumDataDisplay,
    ChartHistogram: UniversalBarChart,
    Button,
  },
  props: {
    similarityAnalysisResult: {
      type: Object as PropType<SimilarityAnalysisResult>,
    },
  },
  data(): {
    name: string;
    description: string;
    avgSimilarityText: string;
    totalErrorCountText: string;
    totalImageCountText: string;
    sortedSeries: number[];
    sortedLabels: string[];
    selectedIndex?: number;
  } {
    return {
      name: '',
      description: '',
      avgSimilarityText: '',
      totalErrorCountText: '',
      totalImageCountText: '',
      sortedSeries: [],
      sortedLabels: [],
      selectedIndex: undefined,
    };
  },
  created() {
    // let totalErrorCount = 0;
    let totalImageCount = 0;
    let totalErrorImageCount = 0;

    this.avgSimilarityText =
      (
        (this.similarityAnalysisResult.analysis_list.reduce(
          (sum: number, simItem) => {
            // totalErrorCount += simItem.error_list.length;
            totalImageCount += simItem.total;
            if (simItem.frequency_list)
              totalErrorImageCount += simItem.frequency_list.length;
            return sum + simItem.average_similarity;
          },
          0,
        ) /
          this.similarityAnalysisResult.analysis_list.length) *
        100
      ).toFixed(2) + '%';

    // this.totalErrorCountText = totalErrorCount.toLocaleString('ko-KR');
    this.totalErrorCountText = totalErrorImageCount.toLocaleString('ko-KR');
    this.totalImageCountText = totalImageCount.toLocaleString('ko-KR');

    /** 분포 데이터를 재정렬 ( `< 90`와 같은 키가 뒤로 밀려나는 문제가 있어서) */
    const bar =
      this.$store.getters.similarityAnalysis.similarity_distribution.bars;
    this.sortedSeries = Object.values<number>(bar);
    this.sortedLabels = Object.keys(bar);
    const targetData = this.sortedSeries.splice(10, 1)[0];
    const targetLabel = this.sortedLabels.splice(10, 1)[0];
    this.sortedSeries.unshift(targetData);
    this.sortedLabels.unshift(targetLabel);
  },
  computed: {},
  methods: {
    downloadAnalysisResult() {
      exportJSONToFile(this.similarityAnalysisResult, 'similarity.json');
    },
    handleOnClickItem(index: number) {
      if (this.selectedIndex === index) {
        this.$emit('change', undefined);
        this.selectedIndex = undefined;
      } else {
        this.$emit('change', index);
        this.selectedIndex = index;
      }
    },
  },
});
